import { WebsiteLevel } from "../types/WebsiteConfig";
import { Config } from "../services/Config";

class ProfileFilter {
  SearchLevel: WebsiteLevel = Config.API.WebsiteLevel;
  SearchGuid: string = Config.API.WebsiteId;
  SearchGuids: string[] = [];

  constructor(init?: Partial<ProfileFilter>) {
    if(init) Object.assign(this, init);
  }
}

export { ProfileFilter }
